// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from "react";
// import PropTypes from 'prop-types';
import { css } from "glamor";
import _ from "lodash";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import Link from "gatsby-link";
import { Button } from "antd";
import { Elements, applyType, applyRhythm } from "@bodhi-project/typography";
import {
  OutLink,
  Image,
  TetraGrid as TetraGridX
} from "@bodhi-project/components";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import feature1 from "../assets/feature1.jpg";
import feature2 from "../assets/feature2.jpg";
import feature3 from "../assets/feature3.jpg";
import feature4 from "../assets/feature4.jpg";
import DefaultSection from "../components/DefaultSection";
import DLT from "../assets/dlt.png";
import DRM from "../assets/drm.png";
import IPR from "../assets/iprights.png";
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { H1, H3 } = Elements;

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Blocks
import SectionBode from "@bodhi-project/blocks/lib/SectionBode";
import SectionMilkyway from "@bodhi-project/blocks/lib/SectionBode";

const bodeData = {
  lead: {
    title: "Digital Media Reserve",
    text:
      "Digital Media Reserve offers Web Services which include a Centralized Repository of your digital publications and the (sales) Fulfillment of DRM-protected eBooks in industry standard file formats - EPUB and PDF/A Formats. A Web Service is a method of communications between two electronic devices over the World Wide Web. Publishers and retailers upload their eBook files to Digital Media Reserve's digital warehouse and integrate with Digital Media Reserve via its APIs in order to sell or distribute your digital publications in a secured environment."
  },
  features: [
    {
      figure: `${IPR}`,
      text:
        "Protect the IP rights of your digital publications by implementing a publishing workflow seamlessly integrated with a robust and scalable digital studio."
    },
    {
      figure: `${DRM}`,
      text:
        "Digital Media Reserve is a powerful yet flexible implementation of the best-of-the-breed digital rights management (DRM) application - Adobe Content Server, version 6.5. "
    },
    {
      figure: `${DLT}`,
      text:
        "We are currently designing a distributed ledger technology (DLT) and blockchain based publishing chain that would enhance the rights management and supply chain significantly."
    }
  ]
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { TetraGrid, Hex } = TetraGridX;
const { H2, Paragraph } = Elements;

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Functions
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
const blockStyle = css({
  backgroundImage: "#33cccc",
  minHeight: "75vh",
  alignItems: "center",
  paddingTop: "8vh",
  paddingBottom: "4vh",

  "& .css-1xv0s77": {
    paddingTop: 0
  },

  "& .boe-lead h2 span": {
    display: "none",
    padding: 0,
    margin: 0,
    color: "#FFFFFF"
  },

  "& H1": {
    color: "#FFFFFF"
  },

  "& .boe-lead p span": {
    color: "#FFFFFF"
  },

  "& .boe-block": {
    backgroundColor: "#FFFFFF"
  },

  "& .boe-block-text": {},

  "& .feature": {
    border: "0",
    background: "0px"
  },

  "& .hex": {
    boxShadow: "unset"
  },

  "& .ant-btn-primary": _.merge(
    { ...applyType("ltb1ekq") },
    {
      fontWeight: 700,
      fontStyle: "italic",
      borderRadius: 0,
      backgroundColor: "#f7d708",
      borderColor: "transparent",
      borderWidth: 0,
      color: "#3f3f3f !important",
      height: "auto",
      transition: "all 200ms cubic-bezier(0.78, 0.14, 0.15, 0.86)",
      "&:not(:last-child)": {
        marginRight: "20px"
      },

      "&:hover": {
        backgroundColor: "#f7d708 !important",
        transform: "scale(1.1)",
        borderBottom: "unset !important"
      },

      "& a": {
        color: "#3f3f3f !important",
        borderBottom: "1.625px solid transparent !important",

        "&:hover": {
          color: "#3f3f3f !important",
          borderBottom: "1.625px solid transparent !important"
        }
      }
    },
    ...applyRhythm({ padding: "0.15X 1.15X" })
  )
});
const blockStyleClass = blockStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** WhatIsNimasMaster */
class WhatIsNimasMaster extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props);
  }

  /** standard renderer */
  render() {
    return (
      <DefaultSection className={blockStyleClass}>
        <H1 style={{ color: "#ffffff" }}>
          Secure your digital publications, share online with confidence!
        </H1>
        <SectionBode data={bodeData} />
      </DefaultSection>
    );
  }
}

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default WhatIsNimasMaster;



// WEBPACK FOOTER //
// ./src/blocks/LandingFeatures.jsx